import React from "react";
import { footerTemplates, nav } from "../mock";

const Footer = () => {
  const row = [...footerTemplates, ...footerTemplates, ...footerTemplates];
  return (
    <footer className="bg-[#ececec] pt-20 pb-10 overflow-hidden">
      <div className="relative pause-on-hover mb-16">
        <div className="flex w-max animate-marquee-left gap-6" style={{ "--marquee-duration": "32s" }}>
          {row.map((src, i) => (
            <div key={i} className="w-[320px] h-[220px] rounded-2xl overflow-hidden shrink-0 bg-[#ddd]">
              <img src={src} alt="template" className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1240px] mx-auto px-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 border-t border-[#d5d5d5] pt-8">
          <span className="font-cal text-3xl text-[#ff4d17]">{nav.logo}</span>
          <div className="flex flex-wrap items-center gap-6 text-sm text-[#5f5f5f]">
            {nav.links.map((l) => (
              <a key={l.label} href={l.href} className="hover:text-[#ff4d17] transition-colors">
                {l.label}
              </a>
            ))}
            <a href="#contact" className="hover:text-[#ff4d17] transition-colors">Contact</a>
          </div>
          <span className="text-sm text-[#8a8a8a]">© {new Date().getFullYear()} Agero. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
